var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundChargebackReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.35 2.49992H13.8333C14.75 2.49992 15.5 3.24992 15.5 4.16659V15.8333C15.5 16.7499 14.75 17.4999 13.8333 17.4999H2.16667C1.25 17.4999 0.5 16.7499 0.5 15.8333V4.16659C0.5 3.24992 1.25 2.49992 2.16667 2.49992H5.65C6 1.53325 6.91667 0.833252 8 0.833252C9.08333 0.833252 10 1.53325 10.35 2.49992ZM7.16667 3.33325C7.16667 3.79159 7.54167 4.16659 8 4.16659C8.45833 4.16659 8.83333 3.79159 8.83333 3.33325C8.83333 2.87492 8.45833 2.49992 8 2.49992C7.54167 2.49992 7.16667 2.87492 7.16667 3.33325ZM4.18333 11.6666C4.825 13.1333 6.29167 14.1666 8 14.1666C10.3 14.1666 12.1667 12.2999 12.1667 9.99992C12.1667 7.69992 10.3 5.83325 8 5.83325C6.525 5.83325 5.24167 6.59992 4.5 7.74992L3.41667 6.66658V9.99992H6.75L5.41667 8.66658C5.9 7.73325 6.875 7.08325 8 7.08325C9.60833 7.08325 10.9167 8.39158 10.9167 9.99992C10.9167 11.6083 9.60833 12.9166 8 12.9166C7.00833 12.9166 6.13333 12.4166 5.60833 11.6666H4.18333Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundChargebackReport);
export default __webpack_public_path__ + "static/media/refundChargebackReport.eed53527afc0378909cd4ded3e2a33b8.svg";
export { ForwardRef as ReactComponent };